var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.doctype)?_c(_vm.doctype,_vm._b({tag:"Component"},'Component',_vm.$data,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }